<template>
    <div v-if="!compact">
        <slot />
    </div>
    <BaseModal v-else :is-open="open" :close="() => $emit('close')">
        <div class="bg-white dark:bg-grey-900 rounded-t-xl w-screen px-4 pt-14 pb-6">
            <slot />
        </div>
    </BaseModal>
</template>

<script>
import BaseModal from '~/components/UI/BaseModal.vue';

// The locator of the 3D editors. Inline on desktop; in the mobile row of EditorFields it opens in a modal,
// since dragging the map inside the swiping row scrolls the row instead.
export default {
    name: 'LocationDialog',
    components: { BaseModal },
    inject: { editorFields: { default: null } },
    props: {
        open: { type: Boolean, default: false },
    },
    computed: {
        compact() {
            return !!this.editorFields?.isCarousel;
        },
    },
    watch: {
        open(open) {
            if (open && this.compact) window.scrollTo({ top: 0 });
        },
    },
};
</script>
